var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"traceability-back-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('md-icon',{attrs:{"md-src":"/static/images/icon-arrow-left.svg"}}),_vm._v("\n  Voltar\n")],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }